import { lazy } from 'react'

export const BodyTypeV1 = lazy(() => import('./v1/BodyTypeV1'))
export const BodyTypeV2 = lazy(() => import('./v2/BodyTypeV2'))
export const BodyTypeV3 = lazy(() => import('./v3/BodyTypeV3'))
export const BodyTypeV4 = lazy(() => import('./v4/BodyTypeV4'))
